export enum STEPS {
  LISTS,
  NEW_LIST,
  FEEDBACK,
}

export enum STATUS {
  SUCCESS = 'success',
  DANGER = 'danger',
}

export const ID_WISHLIST_ALL_PRODUCTS = 'all-products';
